import * as React from 'react'
import {
  DateTimeRange,
  Fieldset,
  InputText,
  Legend,
  SearchButton,
} from '@paytrace/pt-skel/Component'

const HINT_DEFAULT = "Please provide the optional search criteria of the transaction(s) you wish to view. This text will be compared against each transaction's invoice number, billing name, shipping name, email address, customer ID and description."

interface Props extends React.ComponentProps<any> {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => any
  setStartDate?: any
  setStartTime?: any
  setEndDate?: any
  setEndTime?: any
  startDate?: string
  endDate?: string
  startTime?: string
  endTime?: string
  setOrderId?: any
  setSearchText?: any
  hintSearchText?: string
}

/**
 * The initial small form display
 */
export function TransactionSearch (props: Props) {
  const hintSearchText = props.hintSearchText || HINT_DEFAULT
  return (
    <Fieldset>
      <Legend title='Search Transactions' />
      <form onSubmit={props.onSubmit}>
        {props.children}

        <DateTimeRange
          setStartDate={props.setStartDate}
          setStartTime={props.setStartTime}
          setEndDate={props.setEndDate}
          setEndTime={props.setEndTime}
          startDate={props.startDate}
          endDate={props.endDate}
          startTime={props.startTime}
          endTime={props.endTime}
        />

        <InputText
          onChange={e => props.setOrderId(e.target.value)}
          label='Order ID'
          placeholder='Optional'
          name='orderid'
          hintText='Please provide the specific Order ID of the transaction you wish to view. Please note that all other search criteria will be disregarded if an Order ID is provided.'
        />

        <InputText
          onChange={e => props.setSearchText(e.target.value)}
          label='Search Text'
          placeholder='Optional'
          name='searchtext'
          hintText={hintSearchText}
        />

        <SearchButton />
      </form>
    </Fieldset>
  )
}

export default TransactionSearch
